import React from "react";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";

const HotelConfigList = (props) => {

    const columns = [
        { field: "hotelName", headerName: "Hotel Name", flex: 1 },
        { field: "phone", headerName: "Phone", flex: 1 },
        { field: "email", headerName: "Email", flex: 1 },
        { field: "city", headerName: "City", flex: 1 },
        {
            field: "logoUrl", headerName: "Logo", flex: 1,
            row: true, renderCell: (row) => row?.logoUrl === null ? "NA" : <div className="uploaded-image">
                <img src={row?.logoUrl} alt={row?.logoUrl} />
            </div>,
            sortDirection: false,
            disableSortIcon: true
        },
    ];


    return (
        <div className="hotel-list">
            <p><b>Hotel Details</b></p>
            <TableWrapper
                data={[props?.fetchCDSNHotelConfigList]}
                columns={columns}
                noPagination={true}
                // module="partner-config"
            />
        </div>
    )
}

export default HotelConfigList;